exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3Kduwk9zES94NTM3L6-ZWb{background-color:transparent!important}", ""]);

// exports
exports.locals = {
	"ant-collapse-borderless": "_3Kduwk9zES94NTM3L6-ZWb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./apps/pages/main/workbench/CoreFirm/index.css
// module id = 1603
// module chunks = 1